const offers = [
  {
    id: 1,
    title: "Buy 1 Get 1 Free",
    subtitle: "On all Medium Pizzas",
    img: "https://assets.box8.co.in/horizontal-rectangle/web/banner/1871",
  },
  {
    id: 2,
    title: "Flat 40% OFF",
    subtitle: "Weekend Special",
    img: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3",
  },
  {
    id: 3,
    title: "Free Dessert 🍰",
    subtitle: "Orders above ₹499",
    img: "https://assets.box8.co.in/horizontal-rectangle/web/banner/1921",
  },
  {
    id: 4,
    title: "Midnight Combo",
    subtitle: "Only ₹299",
    img: "https://assets.box8.co.in/horizontal-rectangle/web/banner/1896",
  },
  {
    id: 5,
    title: "Weekend Special Pizza",
    subtitle: "Flat 30% OFF",
    img: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3",
  },
  {
    id: 6,
    title: "Happy Hours 🍹",
    subtitle: "Buy 2 Get 1 Free",
    img: "https://assets.box8.co.in/horizontal-rectangle/web/banner/1921",
  },
];

export default offers;
